/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-return */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { View } from "./View";
import { Page } from "./Page";
import { $ } from "./$Element";
import { ViewMounted, ViewUnmounted } from "./ViewEvent";
class Rune {
    set(element, instance, Constructor) {
        return this._weakMap.set(element, this._getMap(element).set(Constructor !== null && Constructor !== void 0 ? Constructor : instance.constructor, instance));
    }
    get(element, Constructor) {
        const instance = this._getMap(element).get(Constructor);
        return instance === undefined ? instance : instance;
    }
    _getMap(element) {
        return this._weakMap.get(element) || this._weakMap.set(element, new Map()).get(element);
    }
    getView(element, Constructor) {
        return this.get(element, Constructor);
    }
    getUnknownView(element) {
        return this.get(element, View);
    }
    _getPageByParentView(currentView) {
        do {
            if (currentView instanceof Page) {
                return currentView;
            }
        }while (currentView = currentView.parentView);
    }
    getPage(currentView) {
        let page;
        if (currentView) {
            page = this._getPageByParentView(currentView);
        }
        if (!page && typeof window !== "undefined") {
            const element = document.querySelector("body [data-rune]");
            if (element) {
                page = this.getUnknownView(element);
            }
        }
        return page;
    }
    getSharedData(currentView) {
        var _this_getPage;
        return (_this_getPage = this.getPage(currentView)) === null || _this_getPage === void 0 ? void 0 : _this_getPage.sharedData;
    }
    addMutationObserver(target) {
        const observer = new MutationObserver((records)=>{
            for (const record of records){
                for (const addedNode of record.addedNodes){
                    if (addedNode.nodeType === Node.ELEMENT_NODE) {
                        const subViewElement = addedNode;
                        if (subViewElement.matches("[data-rune]")) {
                            var _$_parentNode_closest, _$_parentNode;
                            (_$_parentNode = $(subViewElement).parentNode()) === null || _$_parentNode === void 0 ? void 0 : (_$_parentNode_closest = _$_parentNode.closest("[data-rune]")) === null || _$_parentNode_closest === void 0 ? void 0 : _$_parentNode_closest.chain((parentViewElement)=>{
                                const subView = rune.getUnknownView(subViewElement);
                                if (subView) {
                                    subView.parentView = rune.getUnknownView(parentViewElement);
                                    subView.element().dataset.runeParent = subView.parentView.toString();
                                }
                            });
                            dispatchEvents(ViewMounted, subViewElement);
                        }
                    }
                }
                for (const removedNode of record.removedNodes){
                    if (removedNode.nodeType === Node.ELEMENT_NODE) {
                        const subViewElement = removedNode;
                        if (subViewElement.matches("[data-rune]")) {
                            const subView = rune.getUnknownView(subViewElement);
                            if (subView) {
                                subView.parentView = null;
                                subView.element().dataset.runeParent = "";
                            }
                            dispatchEvents(ViewUnmounted, subViewElement);
                        }
                    }
                }
            }
        });
        observer.observe(target, {
            childList: true,
            subtree: true
        });
    }
    constructor(){
        _define_property(this, "_weakMap", new WeakMap());
    }
}
export const rune = new Rune();
function dispatchEvents(Event, subViewElement) {
    [
        subViewElement,
        ...subViewElement.querySelectorAll("[data-rune]")
    ].map((element)=>rune.getUnknownView(element)).forEach((subView)=>{
        if (subView) subView.dispatchEvent(Event, {
            detail: subView
        });
    });
}
if (typeof window !== "undefined") {
    window.__rune__ = rune;
    rune.addMutationObserver(document.body);
}
